import { KindeProvider as Provider } from '@kinde-oss/kinde-auth-react'
import { type ReactNode } from 'react'

import { useConfig } from '@/providers/config'

export function KindeProvider({ children }: { children: ReactNode }) {
  const { config, loading, error } = useConfig()

  // TODO handle loading and error better
  if (loading) return <div>Loading auth configuration…</div>
  if (error) return <div className="text-red-600 dark:text-red-400">Error loading config: {error}</div>
  if (!config) return null

  const { clientId, domain } = config.kinde

  if (!clientId || !domain) {
    throw new Error('Missing required kinde config to initialize KindeProvider')
  }

  return (
    <Provider
      clientId={clientId}
      domain={domain}
      useInsecureForRefreshToken={process.env.NODE_ENV === 'development'}
      redirectUri={`${window.location.origin}/auth/callback`}
      logoutUri={window.location.origin}
      callbacks={{
        onSuccess: () => {
          window.location.pathname = '/'
        },
      }}
    >
      {children}
    </Provider>
  )
}
